module.exports = __webpack_public_path__ + "static/media/menuQueue.a93d55ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuQueue.svg
// module id = 493
// module chunks = 0